<template>
	<div v-if="displayDataEdit">
		<b-container>
			<!-- Overall Completion -->
			<b-row> 
				<b-col cols="9">
					<h3> Overall Completion </h3>
				</b-col>
				<b-col v-if="editMode" cols="2" />
				<b-col v-if="!editMode" cols="1" />
				<b-col
					v-if="!editMode"
					cols="1"
					class="date-icon"
				>
					<b-icon 
						v-b-tooltip.hover.top="formatDate(displayDataEdit.overallAsOfDate)"
						icon="clock"
						style="float: right;" 
					/>
				</b-col>
				<b-col
					cols="1"
					class="edit-button"
				>
					<b-button variant="link" @click="edit()">
						Edit
					</b-button>
				</b-col>
			</b-row>

			<b-row v-if="editMode">
				<b-col>
					<b-form-datepicker
						id="datepicker-asset-schedule"
						v-model="displayDataEdit.overallAsOfDate"
						size="sm" 
						locale="en" 
						placeholder="Choose a date"
						:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
					/>
				</b-col>
			</b-row>

			<b-row v-if="editMode">
				<b-col>
					Projected Overall Completion %
					<b-form-input
						id="input-service"
						v-model="displayDataEdit.overallProjectedCompletionPct"
						size="sm"
						type="number"
						placeholder=""
					/>
				</b-col>
			</b-row>

			<b-row v-if="editMode">
				<b-col>
					Actual Overall Completion %
					<b-form-input
						id="input-service"
						v-model="displayDataEdit.overallActualCompletionPct"
						size="sm"
						type="number"
						placeholder=""
					/>
				</b-col>
			</b-row>
			
			<b-row>
				<b-col style="height: 15px" />
			</b-row>
					
			<b-row v-if="!editMode">
				<b-col>
					Projected Completion %
					<b-progress :value="displayDataEdit.overallProjectedCompletionPct" :max="100" class="mb-3" />
				</b-col>
			</b-row>

			<b-row v-if="!editMode">
				<b-col>
					Actual Completion %
					<b-progress :value="displayDataEdit.overallActualCompletionPct" :max="100" class="mb-3" />
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<h3> Phasing </h3>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<schedule-phase-view
						title="planning"
						:data="displayDataEdit"
						:mode="editMode"
						@refresh="refresh()"
					/>
				</b-col>
			</b-row>
			
			<b-row> 
				<b-col>
					<schedule-phase-view
						title="design"
						:data="displayDataEdit"
						:mode="editMode"
						@refresh="refresh()"
					/>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<schedule-phase-view
						title="construction"
						:data="displayDataEdit"
						:mode="editMode"
						@refresh="refresh()"
					/>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<schedule-phase-view
						title="stabilization"
						:data="displayDataEdit"
						:mode="editMode"
						@refresh="refresh()"
					/>
				</b-col>
			</b-row>
			
			<b-row v-if="!editMode">
				<b-col>
					<div class="steady-state">
						<h3> Steady State </h3>
						<div style="margin-top: 5px;">
							<b-icon
								v-if="displayDataEdit.steadyStateReached"
								class="h4"
								icon="check-circle-fill"
								variant="success"
								style="margin-right: 20px;"
							/>
							<b-icon
								v-if="!displayDataEdit.steadyStateReached"
								class="h4"
								icon="check-circle-fill"
								style="color: #C4C4C4; margin-right: 20px;"
							/>
							<b-icon 
								v-b-tooltip.hover.top="formatDate(displayDataEdit.steadyStateAsOfDate)"
								icon="clock"
								style="margin-bottom: 0.7rem !important;"
							/>
						</div>
					</div>
				</b-col>
			</b-row>

			<b-row v-if="editMode">
				<b-col style="height: 15px" />
			</b-row>

			<b-row v-if="editMode">
				<b-col>
					<div class="steady-state">
						<div style="flex: 1; padding: 15px;">
							<h3> Steady-State </h3>
							Steady State Reached
							<b-form-radio-group
								id="radio-group-1"
								v-model="displayDataEdit.steadyStateReached"
								:options="options"
								name="radio-options"
							/>
						</div>

						<div style="flex: 1; padding: 15px;">
							<b-form-datepicker
								id="datepicker_steady_state"
								v-model="displayDataEdit.steadyStateAsOfDate"
								size="sm" 
								locale="en" 
								placeholder="No date selected"
								:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
							/>
						</div>
					</div>
				</b-col>
			</b-row>

			<b-row>
				<b-col style="height: 15px" />
			</b-row>

			<b-row v-if="milestones && milestones.length !== 0">
				<b-col>
					<h3> Milestones </h3>
				</b-col>
			</b-row>

			<b-row v-for="(milestone, id) in milestones" :key="milestone.id">
				<b-col>
					<milestone-view
						:data="milestone"
						:mode="editMode"
						:index="id"
						class="milestone-view"
						@refresh="refresh()"
					/>
					<div v-if="id !== milestones.length" style="height: 15px;" />
				</b-col>
			</b-row>

			<b-row v-if="editMode">
				<b-col style="height: 15px" />
			</b-row>

			<b-row v-if="editMode"> 
				<b-col>
					<b-button block @click="add()">
						Add Milestone
					</b-button>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import SchedulePhaseView from './SchedulePhaseView.vue';
import MilestoneView from './MilestoneView.vue';

export default {
    name: 'AssetSchedule',
	components: {SchedulePhaseView, MilestoneView},
    filters: {},
	props: {},   
    data() {
        return {
			editMode: false,
			displayDataEdit: {},
			milestones: {},
			options: [
				{ value: false, text: 'False' },
				{ value: true, text: 'True' },
			],
        }
    },
    computed: {
		...mapState(['elementEditorEntityDataId']),
		formatDate() {
			return date => (!date || date === '') ? `Not updated`: new Intl.DateTimeFormat('en-US', { dateStyle: 'long' }).format(new Date(date.replace(/-/g, '/').replace(/T.+/, ''))) 
		}
	},
    watch: {
		displayDataEdit: {
			deep: true,
			handler() {
				this.updateData();
			},
		},
		elementEditorEntityDataId: {
			immediate: true,
			deep: true,
			handler() {
				this.getData();
			},
		},
	},
	created() {
		
	},
    mounted() {
	},
    methods: {
		async getData() {
			const assetscheduleData = await this.axios.get(
				`/entities/${this.elementEditorEntityDataId}/assetschedules`
			);
			this.displayDataEdit = assetscheduleData.data;

			const assetmilestoneData = await this.axios.get(
				`/entities/${this.elementEditorEntityDataId}/assetmilestones`
			);
			this.milestones = assetmilestoneData.data;
		},
		async updateData() {
			if (this.displayDataEdit && this.displayDataEdit.id) {
				const postAssetCompanyModelData = await this.axios.patch(
					`/assetschedules/${this.displayDataEdit.id}`,
					this.displayDataEdit
				);
			}
		},
		edit() {
			this.editMode = !this.editMode;
		},
		async add() {
			const newMilestoneModel = {
				asOfDate: null,
				name: '',
				description: '',
				associatedPhases: [],
				projectedDate: null,
				actualDate: null,
				entityId: this.elementEditorEntityDataId,
			}

			const postAssetCompanyModelData = await this.axios.post(
				`/assetmilestones`,
				newMilestoneModel
			);

			this.milestones.push(postAssetCompanyModelData.data);
		},
		async refresh() {
			const assetmilestoneData = await this.axios.get(
				`/entities/${this.elementEditorEntityDataId}/assetmilestones`
			);
			this.milestones = assetmilestoneData.data;
		}
    }
};
</script>

<style scoped>
.btn {
	border: none;
    outline: none;
}
.btn:focus {
    box-shadow: none;
	outline: none;
}
.btn:focus-visible {
    outline: 0;
    border-radius: 0;
}
.btn:hover {
    color: #fff;
    text-decoration: none;
}
.btn-secondary {
	border: none;
    outline: none;
}
.btn-secondary:focus {
    background-color: transparent;
    border-color: transparent;
    box-shadow: none;
	outline: 0;
}
.btn-secondary:hover {
    color: #fff;
    background-color: transparent;
    border-color: transparent;
	outline: none;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
    color: #fff;
    background-color: transparent;
    border-color: transparent;
	outline: none;
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
    box-shadow: none;
}
.btn-secondary:focus-visible {
    outline: 0;
    border-radius: 0;
}
.panel-item-header-button {
	width: 50%;
    background-color: transparent;
}
.panel-item-header-title {
    bottom: 2px;
}
div.service-agreement-view {
    border-radius: 12px;
    border: 1px solid #000000;
    padding: 5px;
	background-color: #e4e4e4;
}
div.empty-image {
	width: 45%;
	height: 120px;
    border-radius: 12px;
    margin: 12px;
	background-color: #d0d0d0;
}
.collapsed .when-open,
.not-collapsed .when-closed {
  display: none;
}
.date-icon {
	margin-top: auto;
	margin-bottom: auto;
	padding-right: 5px;
}
.date-text {
	margin-top: auto;
	margin-bottom: auto;
	padding: 0px;
}
.edit-button {
	margin-top: auto;
	margin-bottom: auto;
	padding: 0px 0px 0px 3px;
}
div.milestone-view {
    border-radius: 12px;
    border: 1px solid #000000;
    padding: 10px;
	background-color: #ffffff;
}
div.steady-state {
	display: flex;
	justify-content: space-between;
    border-radius: 12px;
    border: 1px solid #000000;
    padding: 10px;
	background-color: #ffffff;
}
</style>

<style lang="scss">
</style>